import { Link } from 'react-router-dom';

export default function SafetySection() {
  return (
    <section id="sicherheit" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-start">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-4">
              Sicherheit
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-6">
              Ist OOPBuy Spreadsheet sicher?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              Die Sicherheit bei der Nutzung von OOPBuy Spreadsheet hat höchste Priorität. Das System selbst speichert keine persönlichen Daten und dient ausschließlich als strukturierte Übersichtsplattform. Dennoch ist es wichtig, einige grundlegende Sicherheitsaspekte zu beachten.
            </p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-3 text-sm text-foreground-700">
                <i className="ri-shield-check-line text-primary-500 mt-0.5"></i>
                <span><strong className="text-foreground-900">Datenschutz:</strong> Keine Weitergabe sensibler Daten an Dritte. Die Plattform arbeitet mit transparenten Strukturen.</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-foreground-700">
                <i className="ri-error-warning-line text-accent-500 mt-0.5"></i>
                <span><strong className="text-foreground-900">Fake-Webseiten erkennen:</strong> Achte auf die korrekte Domain und offizielle Quellen, um Betrug zu vermeiden.</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-foreground-700">
                <i className="ri-lock-line text-primary-500 mt-0.5"></i>
                <span><strong className="text-foreground-900">Sichere Nutzung:</strong> Verwende sichere Passwörter und teile keine Zugangsdaten mit unbekannten Quellen.</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-foreground-700">
                <i className="ri-user-settings-line text-accent-500 mt-0.5"></i>
                <span><strong className="text-foreground-900">Nutzerverantwortung:</strong> Jeder Nutzer sollte eigenständig Quellen prüfen und verantwortungsvoll mit Informationen umgehen.</span>
              </li>
            </ul>
          </div>

          <div className="bg-primary-700 rounded-xl p-6 md:p-8 text-white">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-xs font-medium text-primary-200 uppercase tracking-wider">Sicherheits-Check</span>
              <div className="flex gap-1 ml-auto">
                <span className="w-2 h-2 rounded-full bg-white/30"></span>
                <span className="w-2 h-2 rounded-full bg-white/30"></span>
                <span className="w-2 h-2 rounded-full bg-white/30"></span>
              </div>
            </div>
            <blockquote className="text-base md:text-lg font-medium leading-relaxed mb-6">
              &ldquo;OOPBuy Spreadsheet bietet eine transparente und sichere Plattform, um Produkte zu entdecken. Die strukturierte Übersicht hilft dir, informierte Entscheidungen zu treffen, ohne Kompromisse bei der Sicherheit einzugehen.&rdquo;
            </blockquote>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-primary-300 flex items-center justify-center text-primary-800 font-bold text-sm">
                OS
              </div>
              <div>
                <p className="text-sm font-medium">OOPBuy Sicherheitsteam</p>
                <p className="text-xs text-primary-200">Geprüft &amp; verifiziert</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14 overflow-hidden rounded-lg border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-white">
                <th className="text-left px-4 py-3 font-semibold text-foreground-900 border-b border-background-200/70">
                  Risiko
                </th>
                <th className="text-left px-4 py-3 font-semibold text-foreground-900 border-b border-background-200/70">
                  Lösung
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white border-b border-background-100">
                <td className="px-4 py-3 text-foreground-600">Fake Links</td>
                <td className="px-4 py-3 text-foreground-900">Quellen prüfen und nur offizielle Links nutzen</td>
              </tr>
              <tr className="bg-white border-b border-background-100">
                <td className="px-4 py-3 text-foreground-600">Betrügerische Seiten</td>
                <td className="px-4 py-3 text-foreground-900">Domain kontrollieren und auf HTTPS achten</td>
              </tr>
              <tr className="bg-white">
                <td className="px-4 py-3 text-foreground-600">Datenmissbrauch</td>
                <td className="px-4 py-3 text-foreground-900">Sichere Passwörter verwenden und regelmäßig ändern</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center mt-8">
          <Link
            to="/artikel/oopbuy-spreadsheet-sicherheit"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Mehr über Sicherheit erfahren
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}